import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';

import '@fontsource-variable/fraunces';
import '@fontsource-variable/inter';
import './theme.css';
import '@aws-amplify/ui-react/styles.css';

import App from './App';
import outputs from '../amplify_outputs.json';

/*
 * amplify_outputs.json wird von `npx ampx sandbox` (lokal) bzw. vom
 * Amplify-Hosting-Build erzeugt. Der hier eingecheckte Platzhalter enthält nur
 * `{ "version": "1" }`; solange er nicht ersetzt ist, findet die App kein
 * Backend und zeigt nur die statische Startseite. Siehe SETUP.md.
 */
const cfg = outputs as Record<string, unknown>;
if (cfg.auth) {
  Amplify.configure(cfg as Parameters<typeof Amplify.configure>[0]);
} else {
  console.warn('Backend nicht konfiguriert — bitte `npx ampx sandbox` ausführen (siehe SETUP.md).');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
